import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "../common/Header";
import SideBar from "../common/SideBar";
import Button from "../common/Button/Button";
import { GlobalIconNames } from "../../utils/GlobalIconNames";
import AuditTrail from "./AuditTrail";
import CareerList from "./CareerList";

function Careers() {
  const history = useHistory();
  const { type } = useParams();

  const activeTab = type === "auditTrail" ? "auditTrail" : "table";

  return (
    <>
      <Header></Header>
      <div
        className="content-wrapper d-flex flex-wrap new-standard-box"
      >
        <SideBar></SideBar>
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center">
                    <div className="name-w-head d-flex align-items-center">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        Career <span>Library</span>
                      </h4>
                    </div>
                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <Button
                            variant="secondary"
                            iconLeft={<i className="fal fa-chevron-left" />}
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn-white-bordered"
                          >
                            Back
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tabs-wrap">
                  <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                    <li
                      className="nav-item"
                      onClick={() => history.push("/career-library/careers/table")}
                    >
                      <Link
                        className={`nav-link ${activeTab === "table" ? "active" : ""}`}
                        id="pills-tab1"
                        data-toggle="pill"
                        to="/career-library/careers/table"
                        role="tab"
                        aria-controls="pills-tab11"
                        aria-selected="true"
                      >
                        {GlobalIconNames("Careers", "fal fa-briefcase", "Careers").html}
                      </Link>
                    </li>
                    <li
                      className="nav-item"
                      onClick={() => history.push("/career-library/careers/auditTrail")}
                    >
                      <Link
                        className={`nav-link ${activeTab === "auditTrail" ? "active" : ""}`}
                        id="pills-tab2"
                        data-toggle="pill"
                        to="/career-library/careers/auditTrail"
                        role="tab"
                        aria-controls="pills-tab12"
                        aria-selected="false"
                      >
                        {GlobalIconNames("audittrail").html}
                      </Link>
                    </li>
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {activeTab === "table" ? <CareerList /> : <AuditTrail />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
